<template>
  <div>
    <section class="section section-shaped section-lg my-0">
      <div class="pt-lg-md">
        <a target="_blank" :href="benefit.web_site">
        <img :src="benefit.banner" alt="Banner" style="width: 100%">
        </a>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="card" v-if="loading">
                <div class="card-body">
                  <div class="text-center">
                    <img style="max-height: 70px;" v-bind:src="'./img/custom/loading.svg'">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12" v-if="errors.lenght">
              <base-alert type="default">
                <ul>
                  <li v-for="error in errors" v-bind:key="error">{{error}}</li>
                </ul>
              </base-alert>
            </div>
            <div class="col-sm-12" style="font-color: white; margin-top: 15px" v-if="!loading">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-12">
                      <h2 style="border-bottom:1px solid gray">{{benefit.name}}</h2>
                    </div>
                    <div class="col-sm-12" v-if="benefit.categories.length">
                      <h4>Categoría:</h4>
                      <ul>
                        <li
                          v-for="category in benefit.categories"
                          v-bind:key="category.description"
                        >{{category.description}}</li>
                      </ul>
                    </div>
                    <div class="col-sm-12" v-if="benefit.benefit_description">
                      <h4>Descripción del beneficio:</h4>
                      <div v-html="benefit.benefit_description"></div>
                    </div>

                    <div class="col-sm-12" v-if="benefit.shops">
                      <h4>Puntos de Venta:</h4>
                      <div v-html="benefit.shops"></div>
                    </div>

                    <div class="col-sm-12" v-if="benefit.terms_and_conditions">
                      <h4>Términos y condiciones:</h4>
                      <div v-html="benefit.terms_and_conditions"></div>
                    </div>
                    <div class="col-sm-12" v-if="benefit.web_site">
                      <p>
                        <b>Web: </b>
                        <a
                          v-bind:href="benefit.web_site"
                          target="_blank"
                        >{{benefit.web_site}}</a>
                      </p>
                    </div>
                    <div class="col-sm-12" v-if="benefit.facebook">
                      <p>
                        <b>Facebook: </b>
                        <a
                          v-bind:href="benefit.facebook"
                          target="_blank"
                        >{{benefit.facebook}}</a>
                      </p>
                    </div>
                    <div class="col-sm-12" v-if="benefit.instagram">
                      <p>
                        <b>instagram: </b>
                        {{benefit.instagram}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { isArray } from "util";

const axios = require("axios");

export default {
  data() {
    return {
      loading: false,
      errors: [],
      benefit: {
        name: "",
        banner: "",
        categories: [],
        benefit_description: [],
        instagram: "",
        logo: "",
        shops: [],
        web_site: "",
        terms_and_conditions: ""
      }
    };
  },
  methods: {
    async findAlly(slug) {
      this.errors = [];
      this.loading = true;
      try {
        var response = await axios.get(
          "https://hgogjz2lrh.execute-api.us-west-2.amazonaws.com/api/allies/detail?slug=" +
            slug
        );
        if (response.data) {
          switch(response.data){
            case "ally_doesnt_exist":
              case "empty_url":
              this.errors.push("No existen datos");
              break;
          }

          console.log(response.data);

          response.data.banner = response.data.banner.substr(1);
          
          if(Array.isArray(response.data.benefit_description)){
            response.data.benefit_description = await this.arrayToHtml(response.data.benefit_description);
          }
          if(Array.isArray(response.data.terms_and_conditions)){
            response.data.terms_and_conditions = await this.arrayToHtml(response.data.terms_and_conditions);
          }
          if(Array.isArray(response.data.shops)){
            response.data.shops = await this.arrayToHtml(response.data.shops);
          }

          this.benefit = response.data;
        } else {
          this.errors.push(
            "Ocurrió un error al intentar consultar el Beneficio indicado"
          );
        }
        this.loading = false;
      } catch (err) {
        this.errors.push(
          "Ocurrió un error al intentar consultar el Beneficio indicado"
        );
        this.loading = false;
      }
    },
    async arrayToHtml(array){
      if(array.length == 0 ){
        return '';
      }
      var data = [];
      array.forEach(element => {
        let info = "";
        if(element.address){
          info += "<b>Dirección: </b>"+element.address+" ";
        }
        if(element.phone){
          info += "<b>Télefono:</b> "+element.phone+" ";
        }
        if(element.city){
          info += "- "+element.city;
        }
        if(info !=""){
          data.push(info);
        }else{
          data.push(element);
        }
      });
      return '<ul><li>'+data.join('</li><li>')+'</li></ul>';
    }
  },
  mounted: function() {
    this.findAlly(this.$route.params.slug);
  }
};
</script>
<style>
</style>
